import React from 'react';

import ReactDOM from 'react-dom';

 
import _ from 'lodash';
import KeeVue from '../base/KeeVue.js'
import {Tree} from '@jd/find-react';
import $ from 'jquery';

//
const { TreeNode } = Tree;
export default class FsTree extends KeeVue {

    constructor(props) {
        super(props);

        this.state = {
            randId: this.getRandString(),
        }
    }

    componentDidMount() {
        this.registComponent();
    }

    selectNode = (key, e) => {
        //e.stopPropagation();
        this.$emit("select", this.getComponent(e.node.pos));
    }
    // expandChild = (item) => {
    //
    //     // item.showChild = !item.showChild;
    //     // this.setState(this.state);
    // }
    // childSelect = (item) => {
    //     this.$emit("select", item);
    // }
    // childDblClick = (item) => {
    //     this.$emit("dblClick", item);
    // }
    onDoubleClick = (e, node) => {
        //e.stopPropagation();
        this.$emit("dblClick", this.getComponent(node.pos));
    }
    // edit = (item) => {
    //     this.$emit("edit", item);
    // }
    // del = (item) => {
    //     this.$emit("del", item);
    // }
    // onEdit = (item) => {
    //     this.$emit("edit", item);
    // }
    // onDel = (item) => {
    //     this.$emit("del", item);
    // }

    getComponent = (pos)=>{
        let item = this.props.components;
        let posAry = pos.replace('0-', '').split("-");
        posAry.forEach(((value, index, array) => {
            if(index==0)
                item = item[value]
            else
                item = item.child[value]
        }))

        return item;
    }

    renderNode(components){
        return(
                components.map((item, index) => {
                    if (item.showMe || this.props.isMenu == true) {
                        return (
                            <TreeNode
                                id={item.id}
                                key={item.id + index}
                                title={item[this.props.titleField]}>
                                {item.child && this.renderNode(item.child)}
                            </TreeNode>
                        )
                    }
                    return "";
                })
        )
    }

    render() {
        return(
            <div>
                <Tree onSelect={this.selectNode}
                      onDoubleClick={this.onDoubleClick}
                      draggable={true}
                >
                    {this.renderNode(this.props.components)}
                </Tree>

            </div>);

        //
        //     return (
        //
        //         <div>
        //
        //             {
        //
        //                 this.props.components.map((item, index) => {
        //
        //                     if (item.showMe || this.props.isMenu == true) {
        //
        //                         return <div key={item.id + index}>
        //                             <div
        //                                 style={{'paddingLeft': this.props.level !== null ? this.props.level * 20 + 'px' : 0}}
        //                                 className={`kee-role-tree-title  kee-tree-item-${item.orgType} kee-tree-item-${item.className}  kee-tree-item ${item === this.props.selectItem ? 'kee-tree-item-checked' : ''}`}
        //                                 onClick={(e) => this.selectNode(e, item)}
        //                                 onDoubleClick={(e) => this.onDoubleClick(e, item)}>
        //                                 {
        //                                     item[this.props.childField] !== null && item[this.props.childField].length > 0 ?
        //                                         <span>
		// 		<i style={{color: ' #97a8be '}} onClick={() => this.expandChild(item)}
        //            className={item.showChild === true ? 'el-icon-caret-bottom' : 'el-icon-caret-right'}>
		// 		</i>
        //                                             {item[this.props.titleField]}
        //         </span>
        //                                         :
        //                                         <span style={{paddingLeft: '18px'}}>
		// 		  {item[this.props.titleField]}
		// 		</span>
        //                                 }
        //                                 {
        //                                     (this.props.isCanEdit === true || this.props.isCanDel === true) &&
        //                                     <div className={`kee-role-tree-edit`}>
        //                                         <i className={`el-icon-edit  `} onClick={() => this.edit(item)}
        //                                            style={{cursor: ' pointer'}}>
        //                                         </i>
        //                                         <i className={`el-icon-delete2  `} onClick={() => this.del(item)}
        //                                            style={{cursor: ' pointer'}}>
        //                                         </i>
        //                                     </div>
        //                                 }
        //
        //                             </div>
        //                             <div
        //                                 style={{'display': (item.showChild === true && item[this.props.childField] && item[this.props.childField].length > 0 ? 'block' : 'none')}}>
        //                                 <FsTree components={item[this.props.childField]}
        //                                         selectItem={this.props.selectItem} isCanEdit={this.props.isCanEdit}
        //                                         isCanDel={this.props.isCanDel}
        //                                         level={this.props.level ? this.props.level + 1 : 1}
        //                                         onDoubleClick={() => this.onDoubleClick(item)}
        //                                         onSelect={this.childSelect}
        //                                         onDblClick={this.childDblClick}
        //                                         onEdit={() => this.onEdit(item)}
        //                                         onDel={() => this.onDel(item)}
        //                                         titleField={this.props.titleField}
        //                                         isMenu={this.props.isMenu}
        //                                         valueField={this.props.valueField}
        //                                         childField={this.props.childField}>
        //                                 </FsTree>
        //                             </div>
        //                         </div>
        //                     }
        //
        //                     return "";
        //
        //                 })
        //             }
        //
        //         </div>
        //     );
        // return "";
    }
}
